import axios from 'axios'
import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useHistory } from 'react-router'
import { useAuthentication } from '../Authentication/useAuthentication'
import urlSearchParams from '../../components/urlSearchParams'
export const useDealer = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [dealer, setDealer] = useState(false)
  const [loading, setLoading] = useState(false)

  //CATEGORY
  const addDealerLevel = (step, dto, data) => {
    setLoading(true)
    axios
      .post(API.ADD_DEALER(step, dto ? urlSearchParams(dto) : ""), data, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status != 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        // console.log(data.data)
        setDealer(data.data)
        return toastMessage('Dealer level ' + (step) + 'updated successfully', success)
        //  false, loading: false })
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }


const getOneDealer = (id) => {
  setLoading(true)
  axios
    .get(API.GET_DEALER(id), header)
    .then(({ status, data }) => {
      setLoading(false)
      //console.log('DATA : ', data)
      if (status !== 200) {
        return toastMessage('Something Went Wrong !', error)
      }
      console.log(data.data)
      setDealer(data.data)
      //  false, loading: false })
    })
    .catch((err) => {
      setLoading(false)
      if (err.response) {
        //console.log(err.response)
        return toastMessage(err.response.data.error, error)
      }
    })
}




  
  return {
    addDealerLevel,
    getOneDealer,
    dealer
  }
}
